import {CTMWorkOrderViewType} from "../../../../../_core/enum/work-order-type";

export class GeneralDataConfiguration {

  WorkOrder: { Oid: number } | any | null = null;
  importEnabled: boolean = false;
  extraDataJsonEnabled: boolean = false;
  enableExtraDataQuotation : boolean = false;
  nameQuotationHint : string | null = null;
  codeQuotationHint : string | null = null;
  cloneEnabled: boolean = false;
  cloneQuotationEnabled: boolean = false;



  private constructor(public workOrderType: CTMWorkOrderViewType) {
  }

  public static create = (workOrderType: CTMWorkOrderViewType) => new GeneralDataConfiguration(workOrderType);

  setWorkOrderOid(value: number | null) {

    this.WorkOrder = value ? {Oid: value} : null;
    return this;

  }

  enableImport(value: boolean) {

    this.importEnabled = value;
    return this;

  }

  enableExtraDataJson(value: boolean) {

    this.extraDataJsonEnabled = value;
    return this;

  }

}
